// 房型，0：--，1：大床，2：双床
export const ROOM_TYPE_0 = '0';
export const ROOM_TYPE_1 = '1';
export const ROOM_TYPE_2 = '2';
export const ROOM_TYPE_LIST = [
  { value: ROOM_TYPE_0, label: '--' },
  { value: ROOM_TYPE_1, label: '大床' },
  { value: ROOM_TYPE_2, label: '双床' },
];

// 公用是否
export const WHETHER_NO = '0';
export const WHETHER_YES = '1';
export const WHETHER_LIST = [
  { value: '0', label: '否' },
  { value: '1', label: '是' },
];

export const MEETING_YEAR = '2026';